import {Injectable, OnDestroy} from '@angular/core';
import {Observable} from 'rxjs';
import {TaxFormsConfig} from '../../tax-forms/tax-forms-config';
import {HttpClient} from '@angular/common/http';
import {TaxSiteModel} from '../models/tax-sites.model';

@Injectable()
export class TaxSitesService implements OnDestroy {

    constructor(private httpClient: HttpClient) {

    }

    getTaxSites(): Observable<TaxSiteModel> {
        const itrceAPI = TaxFormsConfig.ITRCEApi;
        const url = `${itrceAPI}TaxSites/GetTaxSites`;
        return this.httpClient.get<TaxSiteModel>(url);
    }

    ngOnDestroy(): void {

    }
}
